import { cn } from 'utils/cn';

type Props = {
    title: string;
    /** Sits at the panel's top right, such as the total the panel shows. */
    aside?: React.ReactNode;
    /** Lets a wide table take the panel's full width without padding. */
    flush?: boolean;
    className?: string;
    children: React.ReactNode;
};

/** A titled card around one chart or table of a report. */
export function ChartPanel({ title, aside, flush = false, className, children }: Props) {
    return (
        <section
            aria-label={title}
            className={cn('bg-card ring-foreground/10 flex min-w-0 flex-col rounded-xl ring-1', className)}
        >
            <header className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1 px-5 pt-4 pb-3">
                <h2 className="text-section text-foreground m-0">{title}</h2>
                {aside && <span className="text-caption text-muted-foreground tabular-nums">{aside}</span>}
            </header>
            <div className={cn(!flush && 'px-5 pb-4')}>{children}</div>
        </section>
    );
}
